import styled from 'styled-components'

const paddingH = 30

export const Wrapper = styled.div(({theme}) => ({
  background: theme.colors.bgPaper,
  border: `1px solid ${theme.colors.border}`,
  borderRadius: theme.sizes.radii.default,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  flex: 1,
}))

export const Header = styled.div(({theme}) => ({
  padding: `19px ${paddingH}px 10px`,
  minHeight: 64,
  borderBottom: `1px solid ${theme.colors.border}`,
  display: 'flex',
  flexDirection: 'column',
}))
export const HeaderTop = styled.div(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

export const Title = styled.div(({theme}) => ({
  fontWeight: 500,
  fontSize: theme.fontSizes.medium,
  whiteSpace: 'nowrap',
  marginRight: '0.75em',
}))

export const AssetTableWrapper = styled.div(() => ({
  width: '100%',
  overflowX: 'auto',
  position: 'relative',
  padding: `15px ${paddingH}px`,
}))

export const AssetTable = styled.table(() => ({
  width: '100%',
  borderCollapse: 'collapse',
  textAlign: 'left',
}))

export const AssetTableHeader = styled.thead(() => ({}))
export const AssetTableBody = styled.tbody(() => ({}))

export const AssetTableTh = styled.th(({theme}) => ({
  fontSize: theme.fontSizes.extraSmall,
  color: theme.colors.textSecondary,
  textTransform: 'uppercase',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  padding: '0 10px',
  height: '2em',
  '&:last-child': {
    width: '1%',
    textAlign: 'center',
  },
}))
